import '../EmptyState.scss';

import Paragraph from 'components/TextComps/Paragraph';
import { useTranslation } from 'react-i18next';
import { AddNewClassButton } from '../Classes/AddNewClassButton/AddNewClassButton';

export const NoClassesFound = () => {
  const { t } = useTranslation();

  return (
    <div className='no-data-found'>
      <h2>{t('NoClassesFound', { ns: 'organizationPage' })}</h2>
      <Paragraph>
        <>{t('SeemsLikeYouHaveNotCreatedAnyClasses', { ns: 'organizationPage' })}</>
      </Paragraph>
      <Paragraph>
        <>{t('AddANewOneAndCheckBackAgain', { ns: 'organizationPage' })}</>
      </Paragraph>
      <div className='buttons-wrapper'>
        <AddNewClassButton intent='secondary' />
      </div>
    </div>
  );
};

export default NoClassesFound;
